// Presentation only: preserve the provider status and all billing/access rules.
const validDate = value => {
  if (!value) return null
  const date = new Date(value)
  return Number.isFinite(date.getTime()) ? date.toISOString() : null
}

export const memberSubscription = (item, now = Date.now()) => {
  const status = item.subscriptionStatus || 'INACTIVE'
  const trialEnd = validDate(item.trialEndsAt)
  const freeEnd = validDate(item.freeAccessEndsAt)
  const expiry = validDate(item.subscriptionExpiry)
  const cancellationEnd = validDate(item.subscriptionAccessEndsAt) || trialEnd
  const everApproved = item.approved === true || Boolean(item.firstApprovedAt)
  const sysAdmin = item.permission && (item.permission.sysAdmin || item.permission.name === 'sysAdmin')
  const freeStarted = validDate(item.freeAccessStartedAt)
  const hasFreePeriod = everApproved && !sysAdmin && freeStarted && freeEnd
  const freeActive = hasFreePeriod && !item.freeAccessEndedReason && Date.parse(freeEnd) > now
  const result = (key, label, variant, endsAt = null) => ({
    key, label, variant, endsAt,
  })

  if (status === 'ACTIVE') return result('ACTIVE', 'active', 'success', expiry)
  if (status === 'PAST_DUE') return result('PAST_DUE', 'pastDue', 'danger', expiry)
  if (status === 'TRIAL' && item.subscriptionId) {
    const expired = trialEnd && Date.parse(trialEnd) <= now
    if (!expired) return result('CARD_TRIAL', 'cardTrial', 'info', trialEnd)
    if (!freeActive) return result('INACTIVE', 'cardTrialEnded', 'secondary', trialEnd)
  }
  if (status === 'CANCELED' && cancellationEnd && Date.parse(cancellationEnd) > now) {
    return result('CANCELED', 'canceled', 'secondary', cancellationEnd)
  }
  if (freeActive) return result('TRIAL', 'trial', 'info', freeEnd)
  if (status === 'CANCELED') return result('CANCELED', 'canceled', 'secondary', cancellationEnd)

  // Older manually granted, cardless trials still use trialEndsAt.
  if (status === 'TRIAL' && !item.subscriptionId && trialEnd && everApproved && !sysAdmin) {
    return Date.parse(trialEnd) > now
      ? result('TRIAL', 'trial', 'info', trialEnd)
      : result('INACTIVE', 'trialEnded', 'secondary', trialEnd)
  }
  const subscriptionStart = validDate(item.subscriptionStartedAt)
  const latestFreePeriod = hasFreePeriod && item.freeAccessEndedReason !== 'purchase'
    && (!subscriptionStart || Date.parse(subscriptionStart) < Date.parse(freeEnd))
  if (latestFreePeriod) {
    return result('INACTIVE', item.freeAccessEndedReason === 'revoked' ? 'inactive' : 'trialEnded', 'secondary', freeEnd)
  }
  return result('INACTIVE', 'inactive', 'secondary', expiry)
}

export const normalizeMemberSearch = value => String(value || '')
  .toLocaleLowerCase('tr-TR')
  .replace(/ı/g, 'i')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .replace(/\s+/g, ' ')

export const matchesMemberSearch = (item, query) => {
  const search = normalizeMemberSearch(query)
  if (!search) return true
  const name = item.displayName || `${item.name || ''} ${item.surname || ''}`
  if ([name, item.email, item.phone].some(value => normalizeMemberSearch(value).includes(search))) return true
  // Strip formatting only from phone-like queries; email/name digits are literal.
  if (!/^[+\d\s().-]+$/.test(search)) return false
  const digits = search.replace(/\D/g, '')
  return Boolean(digits && String(item.phone || '').replace(/\D/g, '').includes(digits))
}
